import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ListsPageRoutingModule } from './lists-routing.module';
import { ListsPage } from './lists.page';
import { SharedModule } from '../shared/shared.module';
import { ListSharedModule } from './shared/list-shared.module';
import { EffectsModule } from '@ngrx/effects';
import { ClientListManagementEffects } from './effects/client-list-management.effects';
import { ClientListEffects } from './effects/list/client-list.effects';
import { ClientListItemEffects } from './effects/list-item/client-list-item.effects';
import { ClientListGroupEffects } from './effects/list-group/client-list-group.effects';
import { ListProductEffects } from './effects/product/list-product.effects';
import { ClientRecentPurchaseEffects } from './effects/recent/client-recent-purchase.effects';
import { ClientAiListEffects } from './effects/ai-list/client-ai-list.effects';
import { ClientListViewEffects } from './effects/list-view/client-list-view.effects';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    ListsPageRoutingModule,
    ListSharedModule,
    EffectsModule.forFeature([
      ClientAiListEffects,
      ClientListManagementEffects,
      ClientListEffects,
      ClientRecentPurchaseEffects,
      ClientListItemEffects,
      ClientListGroupEffects,
      ListProductEffects,
      ClientListViewEffects,
    ]),
  ],
  declarations: [ListsPage],
})
export class ListsPageModule {}
